import * as React from 'react'
import Img from 'components/common/Img'
import SanityBlock from 'components/common/SanityBlock'
import clsx from 'clsx'

export default function HeroPostcard({ _rawContent, image, imageOnRight }) {
	return (
		<section className="bg-suede-black text-white">
			<div className="grid items-center md:grid-cols-2">
				<Img
					className={clsx('self-stretch', imageOnRight && 'md:order-1')}
					image={image}
				/>

				<div className="[&_h2]:h0 mx-auto max-w-lg px-4 py-12 text-lg md:px-8">
					<SanityBlock body={_rawContent} />
				</div>
			</div>
		</section>
	)
}
